import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HomeButtonComponent } from './home-button.component';
import { IconsModule } from 'lib/modules/feather-icons.module';

@NgModule({
    declarations: [HomeButtonComponent],
    imports: [CommonModule, RouterModule, IconsModule],
    exports: [HomeButtonComponent],
})
export class HomeButtonModule {}
